import {
  columnTypes,
  paginationGridOptions,
  preventPinnedColumnJumpingGridOption,
} from "@src/utils/aggrid_utils";
import {
  ColDef,
  FillOperationParams,
  GetRowIdParams,
  GridOptions,
} from "ag-grid-community";

import { defaultFTEColDefs } from "./resource_planner_utils";

export function getGridOptions(columnsDefs: ColDef[]): GridOptions {
  return {
    ...paginationGridOptions,
    ...preventPinnedColumnJumpingGridOption,
    rowHeight: 60,
    columnDefs: [...columnsDefs],
    suppressCellFocus: false,
    suppressContextMenu: true,
    domLayout: "autoHeight",
    alwaysAggregateAtRootLevel: true,
    defaultColDef: {
      ...columnTypes.default,
      ...defaultFTEColDefs,
      flex: 1,
      autoHeaderHeight: true,
      resizable: false,
    },
    rowSelection: {
      mode: "multiRow",
      selectAll: "filtered",
    },
    selectionColumnDef: {
      width: 100,
      pinned: "right",
      cellClass: "ag-grid-cell no-border",
      sortable: false,
    },

    getRowId: (params: GetRowIdParams) => {
      return params.rowPinned ? 0 : params.data.projectRoleRequestId;
    },
    cellSelection: {
      handle: {
        mode: "fill",
        setFillValue: (params: FillOperationParams) => {
          const isNonAllocationCell = isNaN(
            parseInt(params.column.getColId().substring(0, 4))
          );
          if (isNonAllocationCell && params.direction === "left") {
            return params.currentCellValue;
          }
          return params.values[params.values.length - 1];
        },
      },
    },
  };
}
